import { z } from 'zod';
import { Dateish } from './common';

// ── Importações via planilha (DESIGN-V11 §4) ────────────────────────────────

export const ImportKindSchema = z.enum(['clients', 'resources']);
export type ImportKind = z.infer<typeof ImportKindSchema>;

export const IMPORT_KIND_LABELS: Record<ImportKind, string> = {
  clients: 'Clientes',
  resources: 'Recursos',
};

/**
 * Colunas FIXAS da planilha de cada tipo — fonte única para a API (validação
 * do header + geração da planilha de exemplo) e para o web (texto de ajuda).
 * Derivadas do schema REAL dos módulos:
 * - clients: `name` é o único NOT NULL; `cnpj_cpf` grava em socialRevenue (o
 *   campo que a UI rotula CNPJ/CPF); email/telefone viram um client_contact.
 * - resources: equipments exige name, clientId E equipmentTypeId NOT NULL —
 *   tipo e cliente entram POR NOME e são resolvidos contra os cadastros.
 */
export const IMPORT_CSV_COLUMNS: Record<ImportKind, readonly string[]> = {
  clients: ['nome', 'email', 'telefone', 'cnpj_cpf'],
  resources: ['nome', 'tipo', 'cliente'],
};

/** processamento é síncrono na request: o job nasce terminal */
export const ImportJobStatusSchema = z.enum(['done', 'failed']);
export type ImportJobStatus = z.infer<typeof ImportJobStatusSchema>;

export const IMPORT_JOB_STATUS_LABELS: Record<ImportJobStatus, string> = {
  done: 'Concluída',
  failed: 'Falhou',
};

/** `row` = número da linha na planilha (o header é a linha 1) */
export const ImportJobErrorSchema = z.object({
  row: z.number().int(),
  message: z.string(),
});
export type ImportJobError = z.infer<typeof ImportJobErrorSchema>;

export const ImportJobSchema = z.object({
  id: z.number().int(),
  kind: ImportKindSchema,
  filename: z.string(),
  status: ImportJobStatusSchema,
  totalRows: z.number().int(),
  importedRows: z.number().int(),
  /** cap 100 itens — o excedente é descartado, os contadores seguem corretos */
  errors: z.array(ImportJobErrorSchema),
  createdById: z.number().int().nullable(),
  createdByName: z.string().nullable(),
  createdAt: Dateish,
});
export type ImportJob = z.infer<typeof ImportJobSchema>;

/** limite de linhas de DADOS por planilha; acima disso a request leva 422 */
export const IMPORT_MAX_ROWS = 5000;
/** cap de erros gravados no job */
export const IMPORT_MAX_ERRORS = 100;
